import { useQuery } from "@tanstack/react-query";
import { Entity, emptyPage, Page } from "@/model";
import entityRepository from "@/repository/entityRepository";


interface UsePaginatedEntitiesParams {
    agentId: number;
    page: number;
    size: number;
    is_option_sort: boolean;
    option_list: string;
    sort: string;
    keyword?: string;
    searchType?: string;
}

const getData = async (params: UsePaginatedEntitiesParams) => {
    const { agentId, page, size, is_option_sort, option_list, sort, keyword, searchType } = params;
    const res = await entityRepository.find(agentId, page, size, is_option_sort, option_list, sort, keyword, searchType);
    return res.data?.data || emptyPage<Entity>();
};

export const usePaginatedEntities = ({
    agentId,
    page,
    size,
    is_option_sort,
    option_list,
    sort,
    keyword,
    searchType
}: UsePaginatedEntitiesParams) => {
    return useQuery<Page<Entity>>({
        queryKey: ['page-entities', agentId, page, size, is_option_sort, sort, option_list, keyword, searchType],
        queryFn: async () => getData({ agentId, page, size, is_option_sort, option_list, sort, keyword, searchType }),
        retry: false
    });
};
